<main class="w-full px-8 bg-white py-14 md:py-20 md:px-14">
    <div class="flex items-center justify-between flex-1">
        <h1 class="text-primary-black-01 title-6 md:title-3">Generación de pagarés</h1>

        <div *ngIf="table === 'mostrar'" class="hidden md:flex justify-between items-center px-2.5 rounded bg-primary-gray-02 border w-56 h-9">
            <mat-icon class="w-[14px] h-[12px] min-w-[14px] min-h-[12px]" svgIcon="icons:warning-icon"> </mat-icon>
            <p class="paragraph-5 text-primary-primary-black-01-01">Registro no puede ser procesado</p>
        </div>
    </div>

    <p *ngIf="table === 'oculto'" class="paragraph-4 text-primary-gray-01">Sube un archivo en CSV para empezar</p>
    <div *ngIf="table === 'oculto'">
        <div class="py-5 pt-8">
            <file-upload
                (fileEvent)="setFileInfo($event)"
                [returnFileBase64String]="false"
                [aceptedTypes]="'text/csv'"
                [icon]="'icons:csv-icon'"
                [placeholder]="fileUploadPlaceholder"
                [maxFileSize]="'5MB'"
                [class]="'max-w-[448px]'">
            </file-upload>

            <!-- <mat-progress-bar class="progress-bar" mode="determinate" [value]="uploadProgress" *ngIf="uploadProgress">
			</mat-progress-bar> -->
            <!-- [ngClass]="{
				'bg-primary': fileCsv?.status,
				'bg-primary-gray-01': !fileCsv?.status
			}"  -->
            <!-- <button mat-flat-button
				class="text-lg transition-colors duration-300 ease-in-out text-primary-white-01 title-9 bg-primary"
				[disabled]="!fileCsv?.status || fileUploading" (click)="subirArchivo()">
				Subir archivo
			</button> -->
        </div>
        <!-- <div
			class="border-2 border-primary-gray-01 text-primary-gray-01 w-[28rem] h-44 my-10 flex flex-col justify-center items-center gap-4 rounded border-dashed pt-5 relative">
			<mat-icon class="w-[40px] h-[47.99px] min-w-[40px] min-h-[47.99px]" svgIcon="icons:csv-icon"> </mat-icon>
			<div class="flex flex-col items-center justify-center">
				<p class="paragraph-2 text-primary-primary-black-01-01">
					Arrastre el archivo a esta área o
					<a (click)="temp()" class="underline cursor-pointer text-primary-blue-01">haz click aquí</a>
				</p>
				<p class="paragraph-5 text-primary-primary-black-01-01">Máximo 5 MB - Formato CSV</p>
			</div>
		</div> -->
    </div>
    <div *ngIf="table === 'loading'" class="flex justify-center">
        <!-- <mat-progress-bar class="progress-bar" mode="determinate" [value]="uploadProgress" *ngIf="uploadProgress">
		</mat-progress-bar> -->
        <!-- <div
			class="border-2 text-primary-gray-01 w-[28rem] h-52 my-10 flex justify-center gap-4 pt-10 rounded border-dashed relative">
			<mat-icon class="w-[40px] h-[47.99px] min-w-[40px] min-h-[47.99px]" svgIcon="icons:csv-icon"> </mat-icon>

			<div
				class="absolute bottom-0 border rounded-lg bg-primary-gray-02 w-full h-[100px] border-primary-gray-01 p-4">
				<p class="paragraph-4 text-primary-primary-black-01-01">Completo</p>
				<div class="h-1 w-full rounded-full bg-primary-green-02 mt-3.5"></div>
				<p class="paragraph-5 text-primary-primary-black-01-01 pt-1.5">100% - archivo.csv</p>
			</div>
		</div> -->
    </div>
    <div *ngIf="table === 'error'" class="mt-8 md:mt-[76px] mx-auto">
        <div class="flex flex-col mx-auto items-center justify-center gap-3 py-5 text-center border rounded-2xl border-primary-gray-04 w-[680px]">
            <p class="title-6 text-primary-black-01">¡No es posible procesar el archivo, <br />por favor intente nuevamente!</p>
            <button mat-flat-button color="primary" class="transition-all duration-300 ease-in-out" (click)="table = 'oculto'">Volver</button>
        </div>
    </div>
    <div [ngClass]="{ block: table === 'mostrar', hidden: table !== 'mostrar' }">
        <div class="py-5">
            <!-- <mat-form-field appearance="fill" class="w-72">
				<mat-label>Plantilla</mat-label>
				<mat-select class="h-[54px]" [(value)]="selected">
					<mat-option *ngFor="let food of foods" [value]="food.value">
						{{ food.viewValue }}
					</mat-option>
				</mat-select>
			</mat-form-field> -->
            <mat-form-field appearance="fill" class="w-full md:w-72">
                <mat-label>Plantilla</mat-label>
                <mat-select [(ngModel)]="plantillaSelected">
                    <mat-option *ngFor="let option of modeloOpciones.PLANTILLA" [value]="option.VALOR">
                        {{ option.VALOR ? option.VALOR : 'Seleccione' }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <div *ngIf="table === 'mostrar'" class="flex md:hidden gap-3 items-center px-2.5 rounded bg-primary-gray-02 border w-full h-9">
                <mat-icon class="w-[14px] h-[12px] min-w-[14px] min-h-[12px]" svgIcon="icons:warning-icon"> </mat-icon>
                <p class="paragraph-5 text-primary-primary-black-01-01">Registro no puede ser procesado</p>
            </div>
        </div>

        <!-- ITEMS MOBILE -->
        <div class="grid grid-cols-1 gap-2 md:hidden sm:grid-cols-2">
            <button
                [disabled]="item.GESTIONABLE == 0"
                (click)="handleClick(item)"
                *ngFor="let item of dataSource?.data"
                [ngClass]="{ 'border-primary-blue-01': hasItem(item), 'border-gray-200': !hasItem(item) }"
                class="relative flex flex-col justify-start gap-1 p-4 text-left border-2 rounded-lg">
                <div class="absolute top-5 right-5">
                    <svg *ngIf="!hasItem(item)" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="8" cy="8" r="7.5" stroke="#e5e7eb" />
                    </svg>
                    <svg *ngIf="hasItem(item)" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="8" cy="8" r="8" fill="#0097A9" />
                        <path
                            d="M10.8847 5.2068C11.0256 5.07269 11.213 4.99855 11.4075 5.00002C11.602 5.00149 11.7883 5.07846 11.9272 5.21469C12.066 5.35092 12.1464 5.53575 12.1516 5.73018C12.1567 5.92461 12.0861 6.11343 11.9547 6.2568L7.96471 11.2468C7.8961 11.3207 7.81329 11.38 7.72124 11.4212C7.62919 11.4623 7.52978 11.4845 7.42896 11.4864C7.32814 11.4882 7.22798 11.4698 7.13447 11.432C7.04095 11.3943 6.95601 11.3381 6.88471 11.2668L4.23871 8.6208C4.16502 8.55214 4.10592 8.46934 4.06493 8.37734C4.02394 8.28534 4.00189 8.18603 4.00012 8.08533C3.99834 7.98462 4.01686 7.88459 4.05459 7.79121C4.09231 7.69782 4.14845 7.61298 4.21967 7.54176C4.29089 7.47055 4.37572 7.4144 4.46911 7.37668C4.5625 7.33896 4.66253 7.32043 4.76323 7.32221C4.86393 7.32399 4.96325 7.34603 5.05525 7.38702C5.14725 7.42801 5.23005 7.48712 5.29871 7.5608L7.39271 9.6538L10.8657 5.2288C10.872 5.2211 10.8776 5.21376 10.8847 5.2068Z"
                            fill="white" />
                    </svg>
                </div>

                <div class="flex items-center gap-3" [ngClass]="{ 'text-primary': item.GESTIONABLE == 0 }">
                    <p class="paragraph-4">RUT: {{ item.RUTDV }}</p>
                    <mat-icon
                        class="w-[13.33px] h-[13.33px] min-w-[13.33px] min-h-[13.33px]"
                        svgIcon="icons:warning-icon"
                        *ngIf="item.GESTIONABLE_RUT == 0">
                    </mat-icon>
                </div>

                <p class="paragraph-4" [ngClass]="{ 'text-primary': item.GESTIONABLE == 0 }">Cuenta: {{ item.CUENTA_FINANCIERA }}</p>

                <p
                    class="paragraph-4 truncate max-w-[150px]"
                    [ngClass]="{ 'text-primary': item.GESTIONABLE == 0 }"
                    matTooltipPosition="above"
                    matTooltipClass="above"
                    [matTooltip]="'IMEI: ' + item.IMEI + '\n PCS: ' + item.PCS">
                    IMEI/Pcs: {{ item.IMEIPCS }}
                </p>

                <p class="paragraph-4" [ngClass]="{ 'text-primary': item.GESTIONABLE == 0 }">Razón Social: {{ item.RAZON_SOCIAL }}</p>

                <div class="flex items-center gap-3" [ngClass]="{ 'text-primary': item.GESTIONABLE == 0 }">
                    <p class="paragraph-4">Monto total: ${{ item.MONTO_TOTAL }}</p>
                    <mat-icon
                        class="w-[13.33px] h-[13.33px] min-w-[13.33px] min-h-[13.33px]"
                        svgIcon="icons:incognito-icon"
                        matTooltipPosition="above"
                        matTooltipClass="above"
                        [matTooltip]="'El monto total es la suma del monto cuota y monto acelerado.'">
                    </mat-icon>
                </div>

                <p class="paragraph-4" [ngClass]="{ 'text-primary': item.GESTIONABLE == 0 }">
                    Fecha Venc. Pagaré: {{ item.FECHA_VENCIMIENTO_PAGARE }}
                </p>

                <p class="paragraph-4" [ngClass]="{ 'text-primary': item.GESTIONABLE == 0 }">N° Contrato: {{ item.NRO_CONTRATO }}</p>

                <p class="paragraph-4" [ngClass]="{ 'text-primary': item.GESTIONABLE == 0 }">Fecha Firma Contrato: {{ item.FECHA_FIRMA_CONTRATO }}</p>

                <p class="paragraph-4" [ngClass]="{ 'text-primary': item.GESTIONABLE == 0 }">
                    Fecha Verif. Pago: {{ item.FECHA_VERIFICACION_DE_PAGO }}
                </p>
            </button>
        </div>

        <!--MAIN TABLE-->
        <div class="hidden md:block">
            <div class="w-full py-2 overflow-auto custom-scroll">
                <table mat-table [dataSource]="dataSource" class="w-full" matSort>
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>
                            <mat-checkbox
                                color="accent"
                                (change)="$event ? toggleAllRows() : null"
                                [checked]="selection.hasValue() && isAllSelected()"
                                [indeterminate]="selection.hasValue() && !isAllSelected()">
                            </mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let row">
                            <mat-checkbox
                                [disabled]="row.GESTIONABLE == 0"
                                color="accent"
                                (click)="$event.stopPropagation()"
                                (change)="$event ? selection.toggle(row) : null"
                                [checked]="selection.isSelected(row)">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="RUTDV">
                        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="RUT" class="px-1.5">RUT</th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            class="paragraph-5 px-1.5 text-left"
                            [ngClass]="{ 'text-primary': element.GESTIONABLE == 0 }">
                            <div class="flex items-center justify-between">
                                {{ element.RUTDV }}
                                <mat-icon
                                    class="w-[13.33px] h-[13.33px] min-w-[13.33px] min-h-[13.33px]"
                                    svgIcon="icons:warning-icon"
                                    *ngIf="element.GESTIONABLE_RUT == 0">
                                </mat-icon>
                                <!-- {{element.GESTIONABLE_RUT == 0}} -->
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="CUENTA_FINANCIERA">
                        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="CUENTA_FINANCIERA" class="px-1.5">CUENTA</th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            class="paragraph-5 px-1.5 text-left"
                            [ngClass]="{ 'text-primary': element.GESTIONABLE == 0 }">
                            {{ element.CUENTA_FINANCIERA }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="IMEIPCS">
                        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="IMEIPCS" class="px-1.5 max-w-[70px]">IMEI/PCS</th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            class="paragraph-5 px-1.5 text-left truncate max-w-[70px]"
                            [ngClass]="{ 'text-primary': element.GESTIONABLE == 0 }"
                            matTooltipPosition="above"
                            matTooltipClass="above"
                            [matTooltip]="'IMEI: ' + element.IMEI + '\n PCS: ' + element.PCS">
                            <p class="truncate">{{ element.IMEIPCS }}</p>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="RAZON_SOCIAL">
                        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="RAZON_SOCIAL" class="px-1.5">RAZÓN SOCIAL</th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            class="paragraph-5 px-1.5 text-left"
                            [ngClass]="{ 'text-primary': element.GESTIONABLE == 0 }">
                            {{ element.RAZON_SOCIAL }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="MONTO_TOTAL">
                        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="MONTO_TOTAL" class="px-1.5">
                            <div class="flex flex-col items-center gap-3 py-3">
                                <div class="flex items-center gap-3">
                                    MONTO TOTAL
                                    <mat-icon
                                        class="w-[13.33px] h-[13.33px] min-w-[13.33px] min-h-[13.33px]"
                                        svgIcon="icons:incognito-icon"
                                        matTooltipPosition="above"
                                        matTooltipClass="above"
                                        [matTooltip]="'El monto total es la suma del monto cuota y monto acelerado.'">
                                    </mat-icon>
                                </div>
                            </div>
                        </th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            class="paragraph-5 px-1.5 text-left"
                            [ngClass]="{ 'text-primary': element.GESTIONABLE == 0 }">
                            <div class="flex items-center justify-center gap-3">
                                ${{ element.MONTO_TOTAL | number: '0.0':'es' }}
                                <mat-icon
                                    class="w-[13.33px] h-[13.33px] min-w-[13.33px] min-h-[13.33px]"
                                    svgIcon="icons:warning-icon"
                                    *ngIf="element.GESTIONABLE_MONTO == 0"
                                    matTooltipPosition="above"
                                    matTooltipClass="above"
                                    [matTooltip]="
                                        'Monto Cuota: $' +
                                        (element.MONTO_CUOTA | number: '0.0':'es') +
                                        '\n Monto Acelerado: $' +
                                        (element.MONTO_ACELERADO | number: '0.0':'es')
                                    ">
                                </mat-icon>
                                <mat-icon
                                    class="w-[13.33px] h-[13.33px] min-w-[13.33px] min-h-[13.33px]"
                                    svgIcon="icons:incognito-icon"
                                    *ngIf="element.GESTIONABLE_MONTO == 1"
                                    matTooltipPosition="above"
                                    matTooltipClass="above"
                                    [matTooltip]="
                                        'Monto Cuota: $' +
                                        (element.MONTO_CUOTA | number: '0.0':'es') +
                                        '\n Monto Acelerado: $' +
                                        (element.MONTO_ACELERADO | number: '0.0':'es')
                                    ">
                                </mat-icon>
                                <!-- {{element.GESTIONABLE_MONTO == 0}} -->
                            </div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="FECHA_VENCIMIENTO_PAGARE">
                        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="FECHA_VENCIMIENTO_PAGARE" class="px-1.5">FECHA VENC. PAGARÉ</th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            class="paragraph-5 px-1.5 text-left"
                            [ngClass]="{ 'text-primary': element.GESTIONABLE == 0 }">
                            {{ element.FECHA_VENCIMIENTO_PAGARE | date: 'dd/MM/yyyy' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="NRO_CONTRATO">
                        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="Nrocontrato" class="px-1.5 max-w-[95px]">N° CONTRATO</th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            class="paragraph-5 px-1.5 text-left max-w-[95px]"
                            [ngClass]="{ 'text-primary': element.GESTIONABLE == 0 }"
                            matTooltipPosition="above"
                            matTooltipClass="above"
                            [matTooltip]="element.NRO_CONTRATO"
                            [matTooltipDisabled]="!(element.NRO_CONTRATO.length > 8)">
                            <p class="truncate">{{ element.NRO_CONTRATO }}</p>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="FECHA_FIRMA_CONTRATO">
                        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="fechaFirma" class="px-1.5">FECHA FIRMA CONTRATO</th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            class="paragraph-5 px-1.5 text-left"
                            [ngClass]="{ 'text-primary': element.GESTIONABLE == 0 }">
                            {{ element.FECHA_FIRMA_CONTRATO | date: 'dd/MM/yyyy' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="FECHA_VERIFICACION_DE_PAGO">
                        <th mat-header-cell *matHeaderCellDef [mat-sort-header]="FECHA_VERIFICACION_DE_PAGO" class="px-1.5">FECHA VERIF. PAGO</th>
                        <td
                            mat-cell
                            *matCellDef="let element"
                            class="paragraph-5 px-1.5 text-left"
                            [ngClass]="{ 'text-primary': element.GESTIONABLE == 0 }">
                            {{ element.FECHA_VERIFICACION_DE_PAGO | date: 'dd/MM/yyyy' }}
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                </table>
            </div>

            <mat-paginator class="flex justify-end text-primary" [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons> </mat-paginator>
        </div>

        <div class="flex flex-col gap-5 py-5 md:flex-row md:gap-20">
            <div class="flex justify-between pr-16 md:justify-start md:gap-40 nd:pr-0">
                <div class="flex flex-col gap-1">
                    <p class="text-sm font-light">Pagarés</p>
                    <span class="title-6">{{ selection.selected.length }}</span>
                </div>
                <div class="flex flex-col gap-1">
                    <p class="text-sm font-light">Monto de pagarés</p>
                    <span class="title-6">${{ totalMonto | number: '0.0':'es' }}</span>
                </div>
            </div>
            <div class="flex flex-col gap-5 md:flex-row">
                <button
                    [disabled]="selection.selected.length === 0 || plantillaSelected == ''"
                    mat-flat-button
                    color="primary"
                    class="transition-all duration-300 ease-in-out"
                    (click)="modalPreview()">
                    Previsualizar PDF
                </button>

                <button
                    [disabled]="selection.selected.length === 0 || plantillaSelected == ''"
                    mat-flat-button
                    color="primary"
                    class="transition-all duration-300 ease-in-out"
                    (click)="generateCarpetas()">
                    Generar PDF
                </button>

                <button
                    [disabled]="selection.selected.length === 0 || deletingRows"
                    mat-flat-button
                    color="primary"
                    class="transition-all duration-300 ease-in-out"
                    (click)="modalEliminar = true">
                    Eliminar
                </button>
            </div>
        </div>
    </div>
</main>

<div
    *ngIf="showModalLoading === 'loading'"
    class="fixed inset-0 grid w-full h-full px-8 bg-opacity-50 bg-primary-black-01 z-99999 place-items-center">
    <div class="w-full max-w-[338px] bg-primary-white-01 rounded-2xl px-5 py-8 md:px-10 md:py-16 flex flex-col gap-7">
        <h1 class="font-bold text-center title-5">¡Un momento!</h1>

        <p class="text-center paragraph-2">Estamos generando los PDFs</p>
        <div class="flex justify-center">
            <mat-spinner class="" [diameter]="30"></mat-spinner>
        </div>
    </div>
</div>

<div *ngIf="showModalLoading === 'error'" class="fixed inset-0 grid w-full h-full px-8 bg-opacity-50 bg-primary-black-01 z-99999 place-items-center">
    <div class="w-full max-w-[338px] bg-primary-white-01 rounded-2xl px-5 py-8 md:px-10 md:py-16 flex flex-col gap-7">
        <button
            class="top-4 right-3 md:right-14 flex gap-3 items-center text-primary-blue-01 font-bold text-[10px]"
            style="margin-left: 185px; margin-top: -32px"
            (click)="closeModalCrear()">
            CERRAR
            <div class="flex items-center justify-center w-6 h-6 mx-auto border rounded-full border-primary-blue-01">
                <mat-icon class="w-[7.4px] h-[7.4px] min-w-[7.4px] min-h-[7.4px]" svgIcon="icons:close-icon"> </mat-icon>
            </div>
        </button>
        <h1 class="font-bold text-center title-5">¡Un momento!</h1>
        <p class="text-center paragraph-2">{{ errorMessage }}</p>
    </div>
</div>

<!-- Modal Loading -->
<div
    *ngIf="showModalLoading === 'mostrar'"
    class="fixed inset-0 grid w-full h-full px-8 bg-opacity-50 bg-primary-black-01 z-99999 place-items-center">
    <div class="w-full max-w-[374px] bg-primary-white-01 rounded-2xl px-5 py-8 md:px-10 md:py-16 flex flex-col gap-7">
        <div class="flex items-center justify-center mx-auto rounded-full bg-primary h-9 w-9">
            <mat-icon class="w-[10px] h-[7px] min-w-[10px] min-h-[7px]" svgIcon="icons:check-icon"> </mat-icon>
        </div>
        <h1 class="font-bold text-center title-5">¡Pagarés generados!</h1>

        <!--TO DO: obtener numero de pagarés efectívamente generados-->
        <p class="text-center paragraph-2">Generaste {{ numPagaresGenerados }} pagarés</p>
        <div class="flex flex-col justify-center gap-3">
            <button mat-flat-button color="primary" class="title-9" (click)="imprimirPagares()" [disabled]="loadingPrint">Imprimir pagarés</button>
            <button
                mat-stroked-button
                disabled="false"
                color="primary"
                (click)="modalOculto()"
                class="border-2 border-primary-red text-primary title-9">
                Hacerlo luego
            </button>
        </div>
    </div>
</div>

<!-- Modal Pdf -->
<div *ngIf="showModalPreview" class="fixed inset-0 grid w-full h-full py-5 bg-opacity-50 bg-primary-black-01 z-99999 place-items-center">
    <div
        class="w-full max-w-[730px] h-full max-h-[1050px] bg-primary-white-01 rounded-2xl px-10 py-2 md:px-20 md:py-2 flex flex-col overflow-auto custom-scroll">
        <div class="relative flex items-center justify-end top-4">
            <!-- <mat-icon class="w-[88px] h-[32px] min-w-[88px] min-h-[32px] mb-4 mt-8" svgIcon="icons:logo-claro-icon"> </mat-icon> -->

            <button class="flex items-center gap-3 text-primary-blue-01 print:hidden" (click)="closeModalPreview()">
                Cerrar
                <div class="flex items-center justify-center mx-auto border-[1px] rounded-full border-primary-blue-01 h-6 w-6">
                    <mat-icon class="w-[7.4px] h-[7.4px] min-w-[7.4px] min-h-[7.4px]" svgIcon="icons:close-icon"> </mat-icon>
                </div>
            </button>
        </div>
        <preview-pagare [arrPagares]="arrPagares" [plantilla]="plantillaSelected"></preview-pagare>
    </div>
</div>

<!-- Modal Eliminar -->
<section *ngIf="modalEliminar" class="fixed inset-0 grid w-full h-full px-8 bg-opacity-50 bg-primary-black-01 z-999 place-items-center">
    <article class="max-w-[494px] bg-primary-white-01 rounded-2xl px-10 py-8 md:px-16 md:pt-18 md:pb-16 relative">
        <button
            class="absolute top-3 right-3 md:right-8 flex gap-3 items-center text-primary-blue-01 font-bold text-[10px]"
            (click)="modalEliminar = false">
            CERRAR
            <div class="flex items-center justify-center w-6 h-6 mx-auto border rounded-full border-primary-blue-01">
                <mat-icon class="w-[7.4px] h-[7.4px] min-w-[7.4px] min-h-[7.4px]" svgIcon="icons:close-icon"> </mat-icon>
            </div>
        </button>
        <h1 class="font-bold text-center title-5">Eliminar</h1>

        <p *ngIf="selection.selected.length === 1" class="my-5 text-black paragraph-2 md:my-8">
            Está seguro de eliminar <span class="paragraph-3">1</span> registro
        </p>
        <p *ngIf="selection.selected.length > 1" class="my-5 text-black paragraph-2 md:my-8">
            Está seguro de eliminar <span class="paragraph-3">{{ selection.selected.length }}</span> registros
        </p>

        <button
            mat-flat-button
            class="flex items-center justify-center w-48 h-10 mx-auto mt-5 btn-md btn-primary"
            [color]="'primary'"
            (click)="borrarSeleccionados()">
            <span>Eliminar</span>
            <!-- <mat-progress-spinner *ngIf="loginForm.disabled" [diameter]="24" [mode]="'indeterminate'">
					</mat-progress-spinner> -->
        </button>
    </article>
</section>
